import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  Box, Text, Button,
} from 'grommet';
import { SimpleModal } from '@Components/Control';
import { shortenInt } from '@Helpers/util';

const StyledButton = styled(Button)`
  text-align: start;
  background-color: ${({ bgColor }) => bgColor ?? 'var(--button-table-bg)'};
  border-radius: var(--app-radius);
  padding: ${({ small }) => (small ? '0.35rem 0.6rem' : '0.25rem 0.5rem')};
  width: fit-content;
  border: 1px solid transparent;
  cursor: pointer;

  &:hover {
    border: 1px solid var(--page-focus-highlight);
  }

  ${({ isOpen }) => isOpen && `
    border: 1px solid var(--page-focus-highlight);
  `}
`;

const ClaimStatusDetails = ({
  small,
  totalClaims,
  claimStats,
  buttonHighlight = 'var(--page-highlight)',
  fallbackHeader = 'Claim status breakdown',
  modalButtonBg = 'var(--button-table-bg)',
}) => {
  const [showModal, setShowModal] = React.useState(false);

  return (
    <Box>
      <StyledButton
        isOpen={showModal}
        onClick={() => setShowModal(true)}
        bgColor={modalButtonBg}
      >
        <Text size={small ? '1rem' : '0.9rem'} weight={500} color="var(--button-table-text)">
          {totalClaims || fallbackHeader}
        </Text>
      </StyledButton>
      {showModal && (
        <SimpleModal
          hideLowerSection
          small={small}
          toggleModal={setShowModal}
          modalTitle="Claim status breakdown"
          textColor="var(--page-modal-text)"
          highlightColor={buttonHighlight}
          modalBg="var(--page-modal-bg)"
          titleSize="1.2rem"
          desktopMinWidth="30rem"
        >
          <Box direction="column" gap="0.75rem" pad={{ vertical: '0.5rem' }}>
            {claimStats.map(({ status, count }) => (
              <Box direction="row" gap="0.5rem" align="center" key={status}>
                <Text size="1rem" color="var(--page-modal-text)" weight={500}>
                  {status}
                  :
                </Text>
                <Text color="var(--page-modal-text)" size="1rem">{shortenInt(count) || 'N/A'}</Text>
              </Box>
            ))}
          </Box>
        </SimpleModal>
      )}
    </Box>
  );
};

ClaimStatusDetails.propTypes = {
  small: PropTypes.bool.isRequired,
  fallbackHeader: PropTypes.string,
  totalClaims: PropTypes.number.isRequired,
  claimStats: PropTypes.arrayOf(PropTypes.shape({
    count: PropTypes.number.isRequired,
    status: PropTypes.string.isRequired,
  })).isRequired,
  buttonHighlight: PropTypes.string,
  modalButtonBg: PropTypes.string,
};

export default ClaimStatusDetails;
